var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/flash-off.73af755d.png","uri@2x": __webpack_public_path__ + "static/media/flash-off.81213afb.png","uri@3x": __webpack_public_path__ + "static/media/flash-off.c3e6cdca.png",
    width: 12,
    height: 19
});